import { BorderRadius, Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

import { Themable } from '../../../types/themable'

export const Container = styled.div<Themable>`
  display: flex;
  padding: ${Spacing.S24};
  border-radius: ${BorderRadius.R8};
  background-color: ${Color.White};
`
